import React from "react";
import ym, { YMInitializer } from "react-yandex-metrika";
import { ACCAUNT_METRIKA, ALLOWED_GOALS } from "./constant";
import { getState } from "helpers";
import { selectToken } from "modules/app";
import { isTrueEnvironment } from "helpers/config";

export const useMetrika = () => {
  const token = selectToken(getState());

  const Metrika = () => {
    if (!token || !isTrueEnvironment) return null;

    return (
      <YMInitializer
        accounts={[ACCAUNT_METRIKA[token]]}
        options={{
          webvisor: true,
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
        }}
        version="2"
      />
    );
  };

  const yandexMetrikaTrack = (eventType) => {
    const goalName = ALLOWED_GOALS[eventType]?.[token];
    if (window.yandex_metrika_accounts && goalName) {
      ym("reachGoal", goalName);
    }
  };

  return { Metrika, yandexMetrikaTrack };
};
